const projectsData = [
  {
    title: "3eSolar Ventures",
    description: "Enterprise solar solution platform with automated remote quotations and system design",
    techStack: ["React", "Node.js", "Express", "MongoDB"],
    images: [
      "/ProjectsSnapshots/3eSolarVentures/1.png",
      "/ProjectsSnapshots/3eSolarVentures/2.png",
      "/ProjectsSnapshots/3eSolarVentures/3.png"
    ]
  },
  {
    title: "4 Prosper Technologies",
    description: "Business intelligence dashboard for financial analytics and performance tracking",
    techStack: ["Vue.js", "D3.js", "Firebase"],
    images: [
        "/ProjectsSnapshots/4 Prosper Technologies/Instagram post - 1.png",
        "/ProjectsSnapshots/4 Prosper Technologies/Instagram post - 2.png",
        "/ProjectsSnapshots/4 Prosper Technologies/Instagram post - 3.png",
        "/ProjectsSnapshots/4 Prosper Technologies/Instagram post - 4.png",
        "/ProjectsSnapshots/4 Prosper Technologies/MacBook Air - 1.png",
     
    ]
  },
  {
    title: "Bilans",
    description: "Automated accounting software with real-time financial reporting",
    techStack: ["Angular", "Spring Boot", "PostgreSQL"],
    images: [
          "/ProjectsSnapshots/Bilans/20.png",
      "/ProjectsSnapshots/Bilans/21.png",
    ]
  },
//   {
//     title: "DriveEase",
//     description: "Fleet management system with vehicle tracking and maintenance scheduling",
//     techStack: ["React Native", "Node.js", "Google Maps API"],
//     images: []
//   },
//   {
//     title: "Ecommerce Laravel",
//     description: "Full-featured online marketplace with inventory management and payment processing",
//     techStack: ["Laravel", "MySQL", "Stripe API"],
//     images: []
//   },
  {
    title: "Electriverse",
    description: "EV ecosystem platform connecting charging stations and vehicle owners",
    techStack: ["React", "Python", "IoT Integration"],
    images: [
          "/ProjectsSnapshots/Electriverse/10.png",
          "/ProjectsSnapshots/Electriverse/11.png",
          "/ProjectsSnapshots/Electriverse/12.png",
          "/ProjectsSnapshots/Electriverse/13.png",
          "/ProjectsSnapshots/Electriverse/14.png",
          "/ProjectsSnapshots/Electriverse/15.png",
        
    ]
  },
//   {
//     title: "Food Delivery Application",
//     description: "End-to-end food delivery service with real-time order tracking",
//     techStack: ["Flutter", "Firebase", "Payment Gateway"],
//     images: [
//           "/ProjectsSnapshots/Food Delivery Application/Instagram post - 24.png",
//           "/ProjectsSnapshots/Food Delivery Application/Instagram post - 25.png",
//           "/ProjectsSnapshots/Food Delivery Application/Instagram post - 26.png",
//           "/ProjectsSnapshots/Food Delivery Application/Instagram post - 27.png",
//           "/ProjectsSnapshots/Food Delivery Application/Instagram post - 28.png",
//           "/ProjectsSnapshots/Food Delivery Application/Instagram post - 29.png",
//           "/ProjectsSnapshots/Food Delivery Application/Instagram post - 30.png",
//           "/ProjectsSnapshots/Food Delivery Application/Instagram post - 31.png",
//     ]
//   },
//   {
//     title: "FyndCareers",
//     description: "AI-powered job matching platform with skills assessment",
//     techStack: ["Next.js", "TensorFlow.js", "MongoDB"],
//     images: []
//   },
//   {
//     title: "LesGo",
//     description: "Ride-sharing application with dynamic pricing and route optimization",
//     techStack: ["React Native", "Node.js", "GeoLocation Services"],
//     images: []
//   },
  {
    title: "MKG Mega Foods",
    description: "B2B food distribution platform with supply chain management",
    techStack: ["React", "Django", "Inventory Management"],
    images: [
         "/ProjectsSnapshots/MKG mega Foods/Instagram post - 1.png",
         "/ProjectsSnapshots/MKG mega Foods/Instagram post - 2.png",
         "/ProjectsSnapshots/MKG mega Foods/Instagram post - 3.png",
         "/ProjectsSnapshots/MKG mega Foods/Instagram post - 4.png",
         "/ProjectsSnapshots/MKG mega Foods/Instagram post - 5.png",
         "/ProjectsSnapshots/MKG mega Foods/Instagram post - 6.png",
         "/ProjectsSnapshots/MKG mega Foods/Instagram post - 7.png",
         "/ProjectsSnapshots/MKG mega Foods/Instagram post - 8.png",
          
    ]
  },
//   {
//     title: "FloraScan",
//     description: "Plant identification mobile application using computer vision",
//     techStack: ["TensorFlow Lite", "React Native", "PlantDB API"],
//     images: []
//   },
//   {
//     title: "PredictAI",
//     description: "Machine learning platform for business forecasting and analytics",
//     techStack: ["Python", "Scikit-learn", "Data Visualization"],
//     images: []
//   },
  {
    title: "Pushti Amritulya",
    description: "Dairy production monitoring system with quality control",
    techStack: ["IoT Sensors", "React Dashboard", "Supply Chain"],
    images: [
         "/ProjectsSnapshots/Pushti Amritulya/MacBook Pro 14_ - 20.png",
         "/ProjectsSnapshots/Pushti Amritulya/MacBook Pro 14_ - 21.png",
         "/ProjectsSnapshots/Pushti Amritulya/MacBook Pro 14_ - 22.png",
         "/ProjectsSnapshots/Pushti Amritulya/MacBook Pro 14_ - 23.png",
         "/ProjectsSnapshots/Pushti Amritulya/MacBook Pro 14_ - 26.png",

    ]
  },
  {
    title: "Shri Balaji Cement Products",
    description: "Industrial material tracking system with order fulfillment",
    techStack: ["ERP Integration", "Java", "Inventory Management"],
    images: [
         "/ProjectsSnapshots/Shri Balaji Cement Product/16.png",
         "/ProjectsSnapshots/Shri Balaji Cement Product/17.png",
         "/ProjectsSnapshots/Shri Balaji Cement Product/18.png",
         "/ProjectsSnapshots/Shri Balaji Cement Product/19.png",
        
    ]
  },
  {
    title: "Shri Bajrang Precast Wall",
    description: "Industrial material tracking system with order fulfillment",
    techStack: ["ERP Integration", "Java", "Inventory Management"],
    images: [
         "/ProjectsSnapshots/Shree Bajrang Precast/22.png",
         "/ProjectsSnapshots/Shree Bajrang Precast/23.png",
         "/ProjectsSnapshots/Shree Bajrang Precast/24.png",
        
        
    ]
  },
  {
    title: "Shri Krishna Publications",
    description: "Digital publishing platform with content management",
    techStack: ["CMS", "eBook Conversion", "Digital Rights"],
    images: [
         "/ProjectsSnapshots/Shri Krishna Publications/MacBook Pro 14_ - 15.png",
         "/ProjectsSnapshots/Shri Krishna Publications/MacBook Pro 14_ - 16.png",
         "/ProjectsSnapshots/Shri Krishna Publications/MacBook Pro 14_ - 17.png",
         "/ProjectsSnapshots/Shri Krishna Publications/MacBook Pro 14_ - 18.png",
         "/ProjectsSnapshots/Shri Krishna Publications/MacBook Pro 14_ - 19.png",

        
    ]
  },
//   {
//     title: "Spurvo",
//     description: "CRM solution for service businesses with client management",
//     techStack: ["Salesforce Integration", "React", "Analytics"],
//     images: []
//   },
  {
    title: "Urban Interiors",
    description: "3D interior design studio with augmented reality preview",
    techStack: ["Three.js", "AR Core", "3D Modeling"],
    images: [
         "/ProjectsSnapshots/Urban Interiors/MacBook Pro 14_ - 7.png",
         "/ProjectsSnapshots/Urban Interiors/MacBook Pro 14_ - 7.png",
         "/ProjectsSnapshots/Urban Interiors/MacBook Pro 14_ - 7.png",
         "/ProjectsSnapshots/Urban Interiors/MacBook Pro 14_ - 7.png",
         "/ProjectsSnapshots/Urban Interiors/MacBook Pro 14_ - 7.png",

    ]
  },
  {
    title: "Omidza - Clothing Ecommerce",
    description: "Online fashion store specializing in custom and ready-made clothing with integrated 3D product previews and seamless checkout experience",
    techStack: ["Shopify", "Woo Commerce", "3D Modeling"],
    images: [
         "/ProjectsSnapshots/omidza/image.png",
         "/ProjectsSnapshots/omidza/image1.png",

    ]
  },
  {
    title: "Kaayna - Women Clothing Ecommerce",
    description: "Women-centric clothing brand with a modern e-commerce storefront, offering dynamic catalog management and interactive 3D garment previews",
    techStack: ["Shopify", "Woo Commerce", "3D Modeling"],
    images: [
         "/ProjectsSnapshots/kaayna/web1.png",
         "/ProjectsSnapshots/kaayna/image.png",

    ]
  }
];

export default projectsData;